export default {
  inspector: {
    name: '',
    address: '',
    postCode: '',
    tel: '',
    gasRegNumber: ''
  },
  property: {
    address: '',
    postCode: '',
    landlord: '',
    tenant: ''
  },
  appliances: [
    {
      location: '',
      type: '',
      make: '',
      safetyCheck: ''
    }
  ],
  certification: {
    inspectionDate: '',
    nextInspectionDate: '',
    certificateNumber: '',
    engineerSignature: '',
    engineerName: ''
  }
};
